import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@progress/kendo-react-buttons";

interface OwnProps {
  readonly onClick?: () => void;
  readonly expanded: boolean;
}

export function ToggleButton({ onClick, expanded }: OwnProps) {
  return (
    <Button onClick={onClick} style={{ marginLeft: "10px" }}>
      {expanded ? (
        <FontAwesomeIcon icon={faChevronUp} />
      ) : (
        <FontAwesomeIcon icon={faChevronDown} />
      )}
    </Button>
  );
}
